import { render, staticRenderFns } from "./tableRevenda.vue?vue&type=template&id=73863254&scoped=true&"
import script from "./tableRevenda.vue?vue&type=script&lang=js&"
export * from "./tableRevenda.vue?vue&type=script&lang=js&"
import style0 from "./tableRevenda.vue?vue&type=style&index=0&id=73863254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73863254",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSimpleTable,VSkeletonLoader})
